import {post, get} from '@/utils/request'

/**
 * 生成uuid
 */
export function generateId(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/generateId'
    })
}

/**
 * 查询分销规则
 */
export function getTypeListAPI(data) {
    data.url = 'commission/dc-commission-rule/list'
    return post({
        data,
        url: 'commission/dc-commission-rule/list'
    })
}

/**
 * 查询分销列表
 */
export function getDistributionListAPI(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/list'
    })
}

/**
 * 添加分销配置(针对分销类型为 :话费预存分佣)
 */
export function addFeeBillConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/addFeeBillConfig'
    })
}
/**
 * 添加分销配置(针对分销类型为 :产品套餐分佣)
 */
export function addProductPackageConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/addProductPackageConfig'
    })
}

/**
 * 添加分销配置(针对分销类型为 : 靓号分佣 、 2 : 话费分佣 、 3 : 激活奖励)
 */
export function addOrderConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/addOrderConfig'
    })
}
/**
 * 添加分销配置(针对分销类型为 : 设备补贴)
 */
export function addEquipmentSubsidyConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/addEquipmentSubsidyConfig'
    })
}

/**
 * 查询分销配置(针对分销类型为 : 设备补贴)
 */
export function getCommissionInEquipmentSubsidy(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getCommissionInEquipmentSubsidy'
    })
}


/**
 * 添加分销配置对象
 */
export function addConfigMember(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/addConfigMember'
    })
}

/**
 * 查询当前登录会员对应某规则的佣金配置额度(针对分销类型为 : 话费预存分销)
 */
export function getCommissionInFeeBill(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getCommissionInFeeBill'
    })
}

/**
 * 删除分销配置对象
 */
export function delConfigMember(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/delConfigMember'
    })
}


/**
 * 编辑分销配置(针对分销类型为 : 靓号分佣 、 2 : 话费分佣 、 3 : 激活奖励)
 */
export function updateOrderConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/updateOrderConfig'
    })
}


/**
 * 编辑分销配置(针对分销类型为 : 设备补贴)
 */
export function updateEquipmentSubsidyConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/updateEquipmentSubsidyConfig'
    })
}

/**
 * 编辑分销配置(针对分销类型为 :产品套餐分佣)
 */
export function updateProductPackageConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/updateProductPackageConfig'
    })
}

/**
 * 编辑分销配置(针对分销类型为 : 话费预存分佣)
 */
export function updateFeeBillConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/updateFeeBillConfig'
    })
}

/**
 * 查询当前登录会员对应某规则的佣金配置额度(针对分销类型为 : 靓号分佣 、 2 : 话费分佣 、 3 : 激活奖励)
 */
export function getCommissionInOrderType(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getCommissionInOrderType'
    })
}

/**
 * 编辑查询分销配置
 */
export function getEditCommissionConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getEditCommissionConfig'
    })
}

/**
 * 查询当前登录会员对应某规则的佣金配置结算方式
 */
export function getCommissionSettlementType(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getCommissionSettlementType'
    })
}

/**
 * 查询某佣金配置信息
 */
export function getCommissionConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getCommissionConfig'
    })
}

/**
 * 查询会员列表(过滤掉已配置过规则的会员)
 */
export function commissionMemberList(data) {
    return post({
        data,
        url: 'member/member/commissionMemberList'
    })
}

/**
 * 根据佣金配置id获取会员-详情(配置对象)
 */
export function getConfigMember(data) {
    return post({
        data,
        url: 'member/member/getConfigMember'
    })
}



/**
 * 校验代理商是否有配置过网点佣金
 */
export function existsWdConfig(data) {
    return post({
        data,
        url: 'member/member/existsWdConfig'
    })
}


/**
 * 校验代理商是否有配置过网点佣金
 */
export function getAddCommissionConfig(data) {
    return post({
        data,
        url: 'commission/dc-commission-config/getAddCommissionConfig'
    })
}


